import React from "react";
import backgroundImage from "../../../../assets/images/CompanyForm.webp";
import { Link, useNavigate } from "react-router-dom";
import { Insights } from "../dashboard/Insights";
import ArrowNext from "../../../../assets/icons/arrowNextWhite.svg";


const FollowNewCompanies = ({ type }) => {
  const navigate = useNavigate();
  // const containerStyles = {
  //   backgroundImage: `url(${backgroundImage})`,
  //   backgroundSize: "cover",
  //   backgroundRepeat: "no-repeat",
  //   backgroundPosition: "top",
  //   height: "30vh"
  // };

  const handleSwitch = () => {
      navigate("/search")
    };



  return (
<div>
    <div className="rounded-[8px] h-[230px] overflow-hidden mb-4">
      <div
        className="text-left lg:max-w-sm rounded-lg shadow p-5"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover', // or try '100% 100%' if 'cover' still crops
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundColor: '#002940',
          width: '100%',
          height: '100%',
          imageRendering: 'auto', // prevents pixelation
        }}
      >
        <div className="w-full md:max-w-[270px] flex flex-col justify-between h-full">
        <div className="w-fit">
  <h4 className="text-[32px] font-semibold tracking-tight text-white font-sans">
    Claim Business
  </h4>
  <p className="font-light text-white text-f16 font-sans w-fit mt-1">
  Claim your businesses and keep their info up to date.
  </p>
</div>
          <button
            className="inline-flex items-center text-sm font-medium text-center"
            onClick={handleSwitch}
          >
            {/* <Link to={"/search"} state={{ redirectToStep: 6 }}> */}
              <img src={ArrowNext} alt="arrow" />
            {/* </Link> */}
          </button>
        </div>
      </div>
    </div>
      <Insights notification_category={type} />
    </div>
    // <div>
    //   <div
    //     className="text-start mb-5 relative sm:h-128  md:h-96 rounded-xl"
    //     style={containerStyles}
    //   >
    //     <div className="p-7 flex gap-8 flex-col">
    //       <div className="flex flex-col gap-4">
    //         <h4 className="text-white text-f24 sm:text-f31 font-semibold">
    //           Access Company
    //         </h4>
    //       </div>
    //       <Link to="/search" target="_blank" className="w-12">
    //         <div className="border p-3 flex justify-start items-start w-12 rounded-md ">
    //           {" "}
              // <svg
              //   width="23"
              //   height="17"
              //   viewBox="0 0 23 17"
              //   fill="none"
              //   xmlns="http://www.w3.org/2000/svg"
              // >
              //   <path
              //     d="M13.5955 15.8614C13.3031 15.5691 13.1628 15.2158 13.1745 14.8016C13.1862 14.3874 13.3387 14.0341 13.6321 13.7417L17.7619 9.61188H1.46189C1.04769 9.61188 0.700248 9.47154 0.419566 9.19086C0.138884 8.91018 -0.000969531 8.56322 5.05841e-06 8.15C5.05841e-06 7.7358 0.140346 7.38836 0.421028 7.10768C0.701709 6.82699 1.04866 6.68714 1.46189 6.68812H17.7619L13.5955 2.52175C13.3031 2.22937 13.157 1.88193 13.157 1.47943C13.157 1.07692 13.3031 0.729967 13.5955 0.438565C13.8879 0.146188 14.2353 0 14.6378 0C15.0403 0 15.3873 0.146188 15.6787 0.438565L22.3668 7.12668C22.513 7.27287 22.6168 7.43124 22.6782 7.60179C22.7396 7.77235 22.7698 7.95508 22.7688 8.15C22.7688 8.34492 22.7381 8.52765 22.6767 8.6982C22.6153 8.86876 22.512 9.02713 22.3668 9.17332L15.6422 15.898C15.3741 16.166 15.0394 16.3 14.6378 16.3C14.2363 16.3 13.8889 16.1538 13.5955 15.8614Z"
              //     fill="white"
              //   />
              // </svg>
    //         </div>
    //       </Link>
    //     </div>
    //   </div>
    //   <div>
    //     <Insights notification_category={type} />
    //   </div>
    // </div>
  );
};

export default FollowNewCompanies;
